var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value:
            !_vm.showFilters &&
            _vm.servicesView == "map" &&
            _vm.workroom != 60 &&
            _vm.workroom != 860,
          expression:
            "( !showFilters && servicesView == 'map' && workroom != 60 && workroom != 860 )",
        },
      ],
      attrs: { id: "map-legend" },
    },
    [
      _c("div", { staticClass: "grid-x" }, [
        _c("div", { staticClass: "large-12 medium-12 small-12 cell" }, [
          _c("span", { staticClass: "legend-title" }, [
            _vm._v(_vm._s(_vm.$t("legend.label"))),
          ]),
        ]),
        _vm._v(" "),
        _vm.showClientPreferenceLegend
          ? _c(
              "div",
              { staticClass: "large-12 medium-12 small-12 cell legend-row" },
              [
                _c("img", { attrs: { src: "/img/service-blue-marker.svg" } }),
                _vm._v(
                  " " + _vm._s(_vm.$t("legend.clientService")) + "\n        "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "large-12 medium-12 small-12 cell legend-row" },
          [
            _c("img", {
              attrs: { src: "/img/service-grass-green-marker.svg" },
            }),
            _vm._v(" " + _vm._s(_vm.$t("legend.slotService")) + "\n        "),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "large-12 medium-12 small-12 cell legend-row" },
          [
            _c("img", {
              attrs: { src: "/img/service-middle-orange-marker.svg" },
            }),
            _vm._v(" " + _vm._s(_vm.$t("legend.normalService")) + "\n        "),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }